/*
 * @Author: Li Xingxing
 * @Email: lixingxing@everimaging.com
 * @Date: 2023-02-03 14:00:19
 * @Description:
 */

import "./ToolLeftSearchTags.scss";

import {
  IconArrawDown,
  IconArrawLeft,
  IconArrawRight,
  IconRight
} from "src/assets";
import React, { useEffect } from "react";
import { actionClickUp, actionGroupClickUp } from "src/analyze/actions";
import {
  useEffectClassifyMap,
  useEffectSelectTags,
  useEffectTags,
  useImageStoreFN,
  useLanguage
} from "src/hooks";

import FTImageStore from "src/store/FTImageStore";
import clsx from "clsx";
import useScroll from "../useScrollBar";

export default function ToolLeftSearchTagsDown() {
  // const [effectTagsList, setEffectTagsList] = React.useState<any>([]);
  const scrollRef = React.useRef<HTMLDivElement>(null);
  const classifyList = useEffectClassifyMap();
  const { t, language } = useLanguage();
  const currentClassify = useImageStoreFN((state) => state.currentClassify);
  const { prevDisabled, nextDisabled, handleNext, handlePrev, handleActive } =
    useScroll(scrollRef, classifyList, language, 32);
  useEffect(() => {
    if (currentClassify) {
      handleActive(
        classifyList.findIndex((item) => item.title === currentClassify) + 2
      );
    }
  }, [classifyList, currentClassify,language]);

  // React.useEffect(() => {
  //   if (expend) {
  //     setEffectTagsList([...effectTags]);
  //   } else {
  //     setEffectTagsList(effectTags.slice(0, 6));
  //   }
  // }, [effectTags, expend]);

  const handleChooseTags = (tag, index) => {
    actionClickUp(tag.id,tag.title,{
      button_position:"goart_effect_classify",
    })
    // actionClickUp(tag, tag)
    FTImageStore.chooseSelectClassify(tag.title);
    handleActive(index + 2);
    actionGroupClickUp(tag.title);
  };
  const handlePrev2 = () => {
    handlePrev();
  };
  const handleSelectAll = () => {
    FTImageStore.clearSelectTags();
    FTImageStore.searchText = "";
    FTImageStore.currentClassify = "";
    FTImageStore.search();
  };
  return (
    <div className='search_tags_down'>
      <div
        className={clsx(
          "search_controller serarch_prev",
          prevDisabled && "search_controller_disabled"
        )}
        onClick={handlePrev2}>
        <div className='search_controller_icon'>
          <IconRight />
        </div>
      </div>
      <div className='search_tags_down_scroll' ref={scrollRef}>
        <span
          key={"All"}
          className={clsx(
            "search_tags_item",
            currentClassify.trim() === "" && "active"
          )}
          onClick={handleSelectAll}>
          {t("tag_all")}
        </span>
        <div className='search_tags_divider'></div>
        {classifyList.map((item, index) => {
          return (
            <span
              key={item.title}
              className={clsx(
                "search_tags_item",
                currentClassify === item.title && "active"
              )}
              onClick={() => handleChooseTags(item, index)}>
              {t(item.key)}
              {item.isNew && <i className='search_tags_item_new'></i>}
            </span>
          );
        })}
      </div>
      <div
        className={clsx(
          "search_controller serarch_next",
          nextDisabled && "search_controller_disabled"
        )}
        onClick={handleNext}>
        <div className='search_controller_icon'>
          <IconRight />
        </div>
      </div>
    </div>
  );
}
